import { SpkGovernanceSkeleton } from './components/skeleton/SpkGovernanceSkeleton'
import { useSpkGovernance } from './logic/useSpkGovernance'
import { GuestView } from './views/GuestView'
import { SpkGovernanceView } from './views/SpkGovernanceView'
import { withSuspense } from '@/ui/utils/withSuspense'

function SpkGovernanceContainer() {
  const spkGovernance = useSpkGovernance()

  if (!spkGovernance.isConnected) {
    return <GuestView {...spkGovernance} />
  }

  return <SpkGovernanceView {...spkGovernance} />
}

const SpkGovernanceContainerWithSuspense = withSuspense(SpkGovernanceContainer, SpkGovernanceSkeleton)
export { SpkGovernanceContainerWithSuspense as SpkGovernanceContainer }
